import { Taskv2 } from "components/tasks/v2/types";
import { VisitParent } from "components/visits/types";
import { AdvancedSearchEntityType } from "generated/graphql";

export const activityParentPath = (parent: VisitParent): string =>
    parent.kind === "contact"
        ? `/references/contacts/show/${parent.id}`
        : `/references/organizations/show/${parent.id}`;

export const taskEntityForParent = (parent: VisitParent): Taskv2["entity"] => ({
    displayName: parent.name,
    path: activityParentPath(parent),
    kind:
        parent.kind === "contact"
            ? AdvancedSearchEntityType.ReferenceContact
            : AdvancedSearchEntityType.ReferenceBusiness,
    contact: null as Taskv2["entity"]["contact"],
});
